export const LANGUAGE_CODES = {
    ENGLISH: 'en',
    UKRAINIAN: 'uk',
    ITALIAN: 'it',
    SPANISH: 'es',
    FRENCH: 'fr',
    GERMAN: 'de',
    CZECH: 'cs',
    POLISH: 'pl',
    BULGARIAN: 'bg',
};

export const LANGUAGE_EXCEPTIONS = {
    [LANGUAGE_CODES.ENGLISH]: {
        phoneCountry: 'us',
    },
    [LANGUAGE_CODES.UKRAINIAN]: {
        phoneCountry: 'ua',
        label: 'UA',
        capitalizeLength: 3,
    },
    [LANGUAGE_CODES.CZECH]: {
        phoneCountry: 'cz',
    },
    [LANGUAGE_CODES.POLISH]: {
        phoneCountry: 'pl',
    },
};
